/**
 * TIFF header — ported from the DI-T1 spike (`jpeg/tiff.ts`, `parseTiff`).
 *
 * The spike's version was write-oriented (it located IFD0's ExifIFDPointer so
 * the writer could repoint it); the write side is DI-5-1's
 * `writeBack/jpeg/writeHead.ts` (`withSubjectDistance` — it reads this
 * header). What is kept here is the header read the IFD walk in `exif.ts`
 * starts from: byte order and the IFD0 offset.
 */

export const TAG_EXIF_IFD = 0x8769;
export const TAG_GPS_IFD = 0x8825;
export const TAG_INTEROP_IFD = 0xa005;

export interface TiffHeader {
  view: DataView;
  little: boolean;
  /** offset of IFD0 inside the TIFF block */
  ifd0: number;
}

/** Returns null when the block does not start with a TIFF header. */
export function readTiffHeader(tiff: Uint8Array): TiffHeader | null {
  if (tiff.byteLength < 8) return null;
  const view = new DataView(tiff.buffer, tiff.byteOffset, tiff.byteLength);
  const bom = view.getUint16(0, false);
  const little = bom === 0x4949;
  if (!little && bom !== 0x4d4d) return null;
  if (view.getUint16(2, little) !== 42) return null;
  return { view, little, ifd0: view.getUint32(4, little) };
}
